/**
 * @typedef {string} ErrorTypes
 */

/**
 * @enum {ErrorTypes}
 */
export const ERROR_TYPES = {
  GENERAL: 'general',
  CSL: 'csl',
  PAIRING: 'pairing',
  PLAYER: 'player',
  LAYOUT: 'layout',
};

/**
 * @typedef {string} ErrorLevels
 */

/**
 * @enum {ErrorLevels}
 */
export const ERROR_LEVELS = {
  FATAL: 'fatal',
  SILENT: 'silent',
};

export const RETRY_ACTIONS = {
  LAYOUT_FETCH: 'layout_fetch',
};
